import React, { Component } from 'react';
import ThemeCardThemeStatus from './ThemeCardThemeStatus';
import LinkedContainer from './theme-card/LinkedContainer';
import Container from './theme-card/Container';
import ParentName from './theme-card/ParentName';
import ThemeName from './theme-card/ThemeName';
import remToPixels from '../utils/remToPixels';
import thronThumbnailResize from '../utils/thronThumbnailResize';
import ThemeLabelContainer from './theme-card/ThemeLabelContainer';

class ThemeCard extends Component {
  static defaultProps = {
    collection: null,
    theme: null,
    status: null,
    containerStyle: null,
  };

  render() {
    const { theme, related = false, containerStyle, ...props } = this.props;
    const isRelatedTheme = related ? 1 : 0;

    const cover = thronThumbnailResize(theme.cover, {
      width: remToPixels(22),
      height: remToPixels(16)
    });

    return (
      <LinkedContainer {...props} related={isRelatedTheme} to={`/seasonal/${theme.collectionId}/themes/${theme.id}`}>
        <Container cover={cover} related={isRelatedTheme} style={containerStyle}>
          <ThemeLabelContainer theme={theme} width="40%" />
          <ParentName related={isRelatedTheme}>{theme.collectionName}</ParentName>
          <ThemeName related={isRelatedTheme}>{theme.name}</ThemeName>
          <ThemeCardThemeStatus light small={related} status={this.props.status}/>
        </Container>
      </LinkedContainer>
    );
  }
}

export default ThemeCard;
